export const calculateProductTotal = ({
  unitPrice,
  quantity,
  length,
  isLinearProduct,
}) => {
  const safeUnitPrice = Number(unitPrice) || 0;
  const safeQuantity = Number(quantity) || 0;
  const safeLength = Number(length) || 0;

  if (isLinearProduct) {
    return Number((safeUnitPrice * safeLength * safeQuantity).toFixed(2));
  }

  return Number((safeUnitPrice * safeQuantity).toFixed(2));
};
